
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  });
}

// Workaround: @bugsnag/plugin-interaction-breadcrumbs in shopify-xr's bundled bugsnag.min.js has pathological O(n²) trim regex on large textContent, causing ~8s main-thread freeze on PDP with high DOM size (see ticket XXX).                                                         
// We inject a no-op bugsnag before xr loads so xr uses our stub via its
// `if (window.bugsnag)` fast-path. Remove when fixed upstream by Shopify/Bugsnag
// or when PDP DOM is reduced below ~50KB textContent threshold.
(function () {
  var client = new Proxy({}, {
    get: function (_, prop) {
      if (prop === 'then') return undefined;
      if (prop === 'getUser' || prop === 'getMetadata') return function () { return {}; };
      if (prop === 'resumeSession') return function () { return true; };
      return function () { return client; };
    },
    has: function () { return true; }
  });
  window.bugsnag = function () { return client; };

  // 健康检查：如果 1 秒内真 bugsnag 被加载，说明 stub 失效
  setTimeout(function () {
    var loaded = performance.getEntriesByType('resource') 
      .some(function (r) { return /d2wy8f7a9ursnm/i.test(r.name); });
    if (loaded && window.__bugsnagStubAlerted !== true) {
      window.__bugsnagStubAlerted = true;
      console.warn('[xr-stub] real bugsnag loaded, stub ineffective');
    }
  }, 1000);
})();

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
